import { render, staticRenderFns } from "./UCProductContact.vue?vue&type=template&id=0bff4533&scoped=true&"
import script from "./UCProductContact.vue?vue&type=script&lang=ts&"
export * from "./UCProductContact.vue?vue&type=script&lang=ts&"
import style0 from "./UCProductContact.vue?vue&type=style&index=0&id=0bff4533&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff4533",
  null
  
)

export default component.exports